/**
 * Shim for `@datadog/mobile-react-navigation`. On the web, Datadog Browser RUM
 * tracks SPA route changes automatically, so view tracking is a no-op here.
 */
export type ViewNamePredicate = (route: any, trackedName: string) => string;

export const DdRumReactNavigationTracking = {
  startTrackingViews: (_navigationRef: unknown, _predicate?: ViewNamePredicate) => {},
  stopTrackingViews: () => {},
};

export default { DdRumReactNavigationTracking };
